const UTM_KEY = '$qualified$utm';

// captures UTM properties on page load and preserves them across the site
export const utmProps = {};

try {
  let storage = JSON.parse(window.localStorage[UTM_KEY] || '{}');
  Object.assign(utmProps, storage);
} catch (err) {
  /* ignore errors */
}

// even if we couldn't parse the stored props, lets try to get new ones
try {
  if (window.URL) {
    const utmTester = /^utm_/;
    const params = new URL(document.location).searchParams;
    if (params) {
      params.forEach((val, key) => {
        const k = key.toLowerCase();
        if (utmTester.test(k) && val) {
          if (val === 'null') {
            delete utmProps[k];
          } else {
            utmProps[k] = val;
          }
        }
      });
      utmProps.referrer = document.referrer;
      utmProps.initialReferrer = utmProps.initialReferrer || document.referrer;
      window.localStorage[UTM_KEY] = JSON.stringify(utmProps);
    }
  }
} catch (err) {
  /* ignore errors */
}
